module.exports = __webpack_public_path__ + "media/images/icons/linkedin-731a5fc63802c8e83b06b386689ebd74.svg";